import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";

import { RegisterAgentForm } from "./type";

export const AgentApi = {
  AgentRegister: (payload: RegisterAgentForm) =>
    axiosRequest.post<ApiResponse>(
      "",
      payloadHelper("AgentRegister", payload.account, payload),
    ),
};
